module.exports = __webpack_public_path__ + "static/media/icon-instagram.90932da4.svg";